import BaseModal from 'components/Modals/BaseModal';
import { Button } from 'react-bootstrap';

function SummaryColumn({ title, items = [], emptyMessage }) {
  return (
    <div className="col-12 col-md-6">
      <div className="border border-light border-opacity-25 rounded-3 overflow-hidden h-100 bg-primary-shadow">
        <div className="bg-dark px-3 py-2 text-center fw-semibold border-bottom border-light border-opacity-25">
          {title}
        </div>
        <div
          className="d-flex flex-column overflow-auto customScrollbar-Y"
          style={{ maxHeight: '16rem', minHeight: '12rem' }}
        >
          {items.length > 0 ? (
            items.map((item, index) => (
              <div
                key={`${title}-${item}-${index}`}
                className={`px-3 py-2 border-bottom border-light border-opacity-10 ${
                  index % 2 ? 'bg-primary-shadow' : 'bg-primary'
                }`}
              >
                <span className="small">{item}</span>
              </div>
            ))
          ) : (
            <div className="px-3 py-3 text-secondary small">{emptyMessage}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function AssociationConfirmationModal({
  show,
  audioFiles = [],
  sirenDevices = [],
  onCancel,
  onConfirm,
}) {
  // Level 3: the device/group settings modal and Audio Manager are below this confirmation.
  return (
    <BaseModal
      show={show}
      handleShow={onCancel}
      size="lg"
      centered
      title={null}
      closeButton={false}
      backgroundColor="var(--bs-body-bg)"
      borderWidth="1px"
      borderColor="var(--bs-secondary)"
      stackLevel={3}
    >
      <div className="d-flex flex-column gap-4">
        <div className="text-center px-2">
          <h5 className="mb-0 fw-semibold">
            Are you sure you want to associate the following audio files to the following Siren
            devices?
          </h5>
        </div>

        <div className="row g-3">
          <SummaryColumn
            title="Audio Files"
            items={audioFiles}
            emptyMessage="No audio files selected."
          />
          <SummaryColumn
            title="Siren Devices"
            items={sirenDevices}
            emptyMessage="No siren devices selected."
          />
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <Button variant="dark" className="px-4 rounded-3" onClick={onCancel}>
            Go Back
          </Button>
          <Button variant="primary" className="px-4 rounded-3" onClick={onConfirm}>
            Yes
          </Button>
        </div>
      </div>
    </BaseModal>
  );
}
